import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-data",
  "use": "icon-data-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-data\">\r\n    <defs>\r\n        <style type=\"text/css\"></style>\r\n    </defs>\r\n    <path d=\"M512 123.19c-19.73 0-39.47 3.71-54.46 11.21L140.06 293.15c-30 15-30 39.48 0 54.46l317.45 158.76c15.05 7.49 34.79 11.21 54.52 11.21s39.48-3.72 54.46-11.21L884 347.61c30-15 30-39.47 0-54.46L566.49 134.4c-15-7.5-34.72-11.21-54.46-11.21z m0 588.36c-24.36 0-48.67-4.87-68.1-14.56L132.87 541.52A30.48 30.48 0 0 1 160.16 487l311 155.53c21.44 10.72 60.31 10.72 81.75 0L863.9 487a30.47 30.47 0 0 1 27.24 54.52L580.14 697A155.78 155.78 0 0 1 512 711.55z m0 188.85c-24.36 0-48.67-4.87-68.1-14.56l-311-155.53a30.44 30.44 0 1 1 27.23-54.46l311 155.53c21.44 10.72 60.31 10.72 81.75 0l311-155.53a30.47 30.47 0 1 1 27.24 54.52l-311 155.47c-19.41 9.75-43.72 14.56-68.12 14.56z\" p-id=\"1585\" fill=\"#ffffff\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/data.svg
// module id = RUrO
// module chunks = 72